/**
 * DIADEM: batches Section Rendering API requests so they stay under Shopify's limit.
 *
 * Shopify's Section Rendering API accepts a MAXIMUM OF 5 sections per request.
 * Ask for 6 and the whole request returns HTTP 400 — verified against
 * /products/elevate-v4-team-98?sections=... (5 -> 200, 6 -> 400).
 *
 * assets/variant-picker.js builds one request containing the main product
 * section plus every section marked `.cc-variant-dependent-section`. The
 * Elevate V4 template has six metafield-bound sections, which takes the request
 * to seven ids. The 400 means the JSON never parses, the `.then()` never runs,
 * and EVERY variant change silently stops working — including plain Grip
 * switching on products that were previously fine.
 *
 * Rather than patch the vendor file (which a Symmetry update would overwrite),
 * this wraps theme.fetchCache.fetch — the single call variant-picker.js makes.
 * Requests of 5 sections or fewer are passed straight through untouched, so
 * nothing changes for any other product. Larger ones are split into chunks of
 * five, fetched in parallel, and merged back into one JSON string with exactly
 * the shape the caller expects.
 *
 * Load order: main.js (defer, in layout) defines theme.fetchCache; this file is
 * deferred and rendered after it, and the first fetch only happens on user
 * interaction, so the wrapper is always in place first.
 */
(function () {
  var MAX_SECTIONS = 5;

  function install() {
    if (!window.theme || !theme.fetchCache || theme.fetchCache.__diademBatched) return false;

    var original = theme.fetchCache.fetch;

    theme.fetchCache.fetch = function (url) {
      var parsed;
      try {
        parsed = new URL(url, window.location.origin);
      } catch (e) {
        return original.call(this, url);
      }

      var sections = (parsed.searchParams.get('sections') || '').split(',').filter(Boolean);
      if (sections.length <= MAX_SECTIONS) return original.call(this, url);

      var self = this;
      var requests = [];
      for (var i = 0; i < sections.length; i += MAX_SECTIONS) {
        var chunkUrl = new URL(parsed.toString());
        chunkUrl.searchParams.set('sections', sections.slice(i, i + MAX_SECTIONS).join(','));
        requests.push(original.call(self, chunkUrl.toString()));
      }

      return Promise.all(requests).then(function (responses) {
        var merged = {};
        responses.forEach(function (text) {
          try {
            var data = JSON.parse(text);
            Object.keys(data).forEach(function (key) { merged[key] = data[key]; });
          } catch (e) {
            /* A failed chunk leaves its sections out of the merge; the rest of
               the page still updates rather than the change dying entirely. */
          }
        });
        return JSON.stringify(merged);
      });
    };

    theme.fetchCache.__diademBatched = true;
    return true;
  }

  if (!install()) {
    document.addEventListener('DOMContentLoaded', install);
    window.addEventListener('load', install);
  }
})();
